"use client";

import { userNamePattern } from "@/00-shared/const";
import { Button } from "@/03-presenters/components/ui/button";
import { Input } from "@/03-presenters/components/ui/input";
import { Label } from "@/03-presenters/components/ui/typography";
import { LoadingOverlay } from "@mantine/core";
import { useRequest } from "ahooks";
import { useRouter } from "next/navigation";
import { useState, useTransition } from "react";
export default function UpdateUserName({
  userName
}: {
  userName: string;
}) {
  const router = useRouter();
  const [isPending, startTransiiton] = useTransition();
  const [isValid, setIsValid] = useState(true);
  function refresh() {
    startTransiiton(() => {
      router.refresh();
    });
  }
  const [isEdit, setIsEdit] = useState(false);
  const [inputUserName, setInputUserName] = useState(userName);
  const {
    runAsync,
    loading
  } = useRequest(async () => {
    const res = await fetch(`/api/user/userName`, {
      method: "POST",
      body: JSON.stringify({
        userName: inputUserName
      })
    });
    const json = await res.json();
    if (json.code === 200) {
      refresh();
      setIsEdit(false);
    }
  }, {
    manual: true
  });
  return <div className="flex items-start gap-2" data-sentry-component="UpdateUserName" data-sentry-source-file="UpdateUserName.tsx">
      <Label className="flex h-6 items-center text-nowrap" data-sentry-element="Label" data-sentry-source-file="UpdateUserName.tsx">用户名称: </Label>
      {isEdit ? <div>
          <Input defaultValue={userName} className="h-6" onChange={e => {
        setInputUserName(e.target.value);
        setIsValid(userNamePattern.test(e.target.value));
      }} />
          {!isValid && <div className="mt-1 text-xs text-red-600">
              3-18个字符，仅支持字母、数字和下划线
            </div>}
        </div> : <div className="relative">
          <LoadingOverlay visible={isPending} zIndex={11} overlayProps={{
        radius: "xs",
        blur: 2
      }} loaderProps={{
        size: 10
      }} />
          <Label className="flex h-6 items-center">{userName}</Label>
        </div>}
      {isEdit ? <div className="flex items-center gap-1">
          <Button variant="link" disabled={loading} className="h-5 px-1 text-primary hover:no-underline" onClick={runAsync}>
            保存
          </Button>
          <Button variant="link" className="h-6 px-1 text-primary hover:no-underline" onClick={() => setIsEdit(false)}>
            取消
          </Button>
        </div> : <Button variant="link" className="h-6 text-primary hover:no-underline" onClick={() => setIsEdit(true)}>
          修改
        </Button>}
    </div>;
}